export function isHtml(html) {
  return /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/.test(html);
}

export function isFunction(func) {
  return typeof func === 'function';
}

export function isPromise(obj) {
  return obj && isFunction(obj.then);
}

export function isString(str) {
  return typeof str === 'string';
}

export function isNumber(str) {
  return typeof str === 'number';
}

export function isBasicType(item) {
  return isString(item) || isNumber(item);
}

/**
 * 判断传入的参数是否是一个对象
 * null或数组会返回false
 * @param {} obj 
 */
export function isObject(obj) {
  return obj
    && typeof obj === 'object'
    && !Array.isArray(obj);
}
